module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.entity,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择券种",
      "prop": "promotionId"
    }
  }, [_c('promotion-select', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.entity.promotionId),
      callback: function($$v) {
        _vm.$set(_vm.entity, "promotionId", $$v)
      },
      expression: "entity.promotionId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "渠道",
      "prop": "dispatchChannelId"
    }
  }, [_c('promotion-dispatch-channel-select', {
    staticStyle: {
      "width": "80%"
    },
    model: {
      value: (_vm.entity.dispatchChannelId),
      callback: function($$v) {
        _vm.$set(_vm.entity, "dispatchChannelId", $$v)
      },
      expression: "entity.dispatchChannelId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生成数量",
      "prop": "expectNum"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.entity.expectNum),
      callback: function($$v) {
        _vm.$set(_vm.entity, "expectNum", _vm._n($$v))
      },
      expression: "entity.expectNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.entity.remark),
      callback: function($$v) {
        _vm.$set(_vm.entity, "remark", $$v)
      },
      expression: "entity.remark"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-aa406f70","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/app/act/promotionCouponBatch/Form.vue
// module id = 351
// module chunks = 0